import React from 'react';
import './Chapters.scss';
import TextWrapPhoto from '../Photos/TextWrapPhoto';
import wrapPhoto1 from '../../Assets/wrapPhoto1.jpg';
import PullQuote from '../PullQuote/PullQuote';

function Chapter2() {
  const photoData = {
    imgSrc: wrapPhoto1,
    caption: '© Island Conservation',
    float: 'right' //pass in "right" or "left"
  };
  return (
    <>
      <section className="chapter" style={{ marginBottom: '-1.5rem' }}>
        <p className="chapter__title">A Race Against Time</p>
        <p className="chapter__paragraph">
          The island—700 kilometers off the coast of Chile—is 50 square kilometers of forests,
          volcanic mountains, and beaches. It’s also home to several species of flora and fauna that
          cannot be found anywhere else on the planet. But since humans began coming to the island
          some 500 years ago, they have introduced invasive species such as rats, coati, and goats.
          As a result, native species such as the Juan Fernandez firecrown hummingbird and the
          Pink-footed shearwater have reached the brink of extinction and the island’s old-growth
          forests have died off.
        </p>
        <p className="chapter__paragraph">
          In total, six bird species and 17 tree species are in grave danger. In a race against time
          to save them, a group of conservationists has partnered with Lenovo in its{' '}
          <a
            href="https://lenovowfh.com/"
            target="_blank"
            rel="noreferrer"
            style={{ color: '#7A126B', textDecoration: 'none', fontWeight: 500 }}
          >
            Work For Humankind
          </a>{' '}
          project to use technology to accelerate and supercharge their efforts to save these
          species—as well as benefit the permanent inhabitants of the island.
        </p>
        <div>
          <TextWrapPhoto photoData={photoData} />
          <p className="chapter__paragraph">
            Bridging the digital divide, Lenovo set up a first-of-its-kind technology hub on the
            island—packed with its high-performance smart devices for productivity, connection, and
            collaboration. What's more, the company has offset the carbon emissions of these
            devices.
          </p>
          <p className="chapter__paragraph">
            The team is also using edge computing and the Lenovo ThinkEdge servers powered by 3
            <sup>rd</sup>
            Gen Intel<sup>®</sup>Xeon<sup>®</sup>Scalable processors with built-in AI acceleration.
            These edge servers process huge amounts of data from cameras and sensors throughout the
            island—powering conservation in the world’s remotest locations.
          </p>
        </div>
      </section>
      <PullQuote
        quote={
          'Though islands comprise only about 5% of the world’s landmass, they possess approximately 20% of the world’s biodiversity.'
        }
      />
      <section className="chapter">
        <p className="chapter__paragraph">
          Because their ecosystems are so fragile, islands have become the epicenters of extinction.
          In fact, the overwhelming majority of reptile, bird, amphibian, and mammal extinctions
          have occurred on islands, and a staggering 86% of those recorded extinctions have been
          caused by invasive species.
        </p>
      </section>
    </>
  );
}

export default Chapter2;
